import './_app.scss';
import {Outlet, useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {useQueryParam} from "./utilities/UseQueryParams";

function App() {
    const [params] = useState(useParams());
    let token = useQueryParam("a");
    let reason = useQueryParam("Reason");
    let errorCode = useQueryParam("ErrorCode");
    let shouldWait = useQueryParam("ShouldWait")
    let navigate = useNavigate();

    useEffect(() => {
        let newApplication = "K9";
        if (localStorage.key("REDIRECT_APP")) {
            newApplication = localStorage.getItem("REDIRECT_APP");
        }

        if (params.application === undefined && params.companyId !== null && params.stage !== null) {
            let companyId = params.companyId;
            let stage = params.stage

            if (token != null) {
                navigate(`${companyId}/${stage}/${newApplication}?a=${token}`);
            } 
            else if (stage === 'Error') {
                navigate(`${companyId}/${stage}/${newApplication}?Reason=${reason}&ErrorCode=${errorCode}`);
            } 
            else if (shouldWait) {
                navigate(`${companyId}/${stage}/${newApplication}?ShouldWait=${shouldWait}`);
            } 
            else {
                navigate(`${companyId}/${stage}/${newApplication}`);
            }
        }

    }, [errorCode, navigate, params, reason, shouldWait, token]);

    return (
        <div className={"Sso-Landing-Page"}>
            <Outlet/>
        </div>
    );
}


export default App;
